import * as actionTypes from './actionTypes';

export const mapGenderNextStep = () => {
  return {
    type : actionTypes.MAP_GENDER_NEXT_STEP,
    val : null
  }
}

export const mapGenderGoBack = () => {
  return {
    type : actionTypes.MAP_GENDER_PREVIOUS_STEP,
    val : null
  }
}

export const mapGenderUploadFileSuccess = (columns, data, file) => {
  return {
    type : actionTypes.MAP_GENDER_UPLOAD_FILE_SUCCESS,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const mapGenderMatchColumnSuccess = (val) => {
  return {
    type : actionTypes.MAP_GENDER_MATCH_COLUMN_SUCCESS,
    val : val
  }
}

export const saveAllGenderMapping = (val) => {
  return {
    type : actionTypes.MAP_GENDER_SAVE_GENDER_MAPPING,
    val : val
  }
}

export const resetGender = () => {
  return {
    type : actionTypes.MAP_GENDER_RESET,
    val : null
  }
}

export const resetMapGenderStep = () => {
  return {
    type : actionTypes.MAP_GENDER_RESET_STEP,
    val : null
  }
}
